import * as React from 'react'

export const HitOutLineMenu = (props: React.ComponentProps<'svg'> | any) => {
  return (
    <svg
      {...props}
      cursor="pointer"
      width="70"
      height="70"
      viewBox="0 0 34 34"
      className="stroke-primary"
    >
      <path
        d="M5.60001 8.4H28M5.60001 16.8H28M5.60001 25.2H15.4"
        strokeWidth="2.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
